<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="users" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Gestão de Utilizadores</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(users)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn @click="estado = 'novo'" color="primary" fab dark small class="plus-btn mb-2" v-on="on">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.nome" label="Nome"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.localidade" label="Localidade"></v-text-field>
                        </v-col>

                        
                        <v-col cols="12">
                          <v-select
                            :id="'new_user_level'"
                            label="Nível de acesso*"
                            item-text="user_level"
                            item-value="user_level_id"
                            :items="[{user_level_id: '0', user_level: 'Farmácia'}, {user_level_id: '1', user_level: 'Interno'}, {user_level_id: '2', user_level: 'Administrador'}]"
                            v-model="editedItem.user_level_id"
                            persistent-hint
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" v-if="editedItem.user_level_id == 0">
                          <v-text-field label="ANF*" :id="'new_anf'" v-model="editedItem.anf" required></v-text-field>
                        </v-col>

                        <!-- <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="show1 ? 'text' : 'password'"
                            label="Password"
                            hint=""
                            counter
                            @click:append="show1 = !show1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password2"
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="show2 ? 'text' : 'password'"
                            label="Confirmar Password"
                            hint=""
                            counter
                            @click:append="show2 = !show2"
                          ></v-text-field>
                        </v-col> -->
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{userMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed class="mr-2" fab dark color="#90A99C" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "users",
  data: () => ({
    search: '',
    estado: "",
    show1: false,
    show2: false,
    password: "",
    password2: "",
    rules: {
      required: value => !!value || "Obrigatório",
      min: v => v.length >= 8 || "Min 8 caracteres",
      emailMatch: () => "O email e password que colocou não correspondem"
    },
    dialog: false,
    headers: [
      
      { text: "ID", value: "id" },
      { text: "ANF", value: "anf" },
      { text: "Nome", value: "nome" },
      { text: "Localidade", value: "localidade" },
      {
        text: "Nome Utilizador",
        align: "start",
        sortable: false,
        value: "username"
      },
      { text: "Nível de Acesso", value: "user_level" },
      { text: "Já entrou?", value: "entrou" },
      { text: "Last login", value: "last_update_dt" },
      { text: "Acções", value: "actions", sortable: false }
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      username: "",
      email: "",
      password: "",
      password2:""
    },
    defaultItem: {},
    createResult: {},
    updateResult: {},
    userMsg: ""
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Novo Utilizador" : "Editar Utilizador";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this.editedItem = {
          username: "",
          email: "",
          password: "",
          password2:""
        }
        this.userMsg = ""
        this.password = ""
        this.password2 = ""
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'users-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch('collectUsers', this)
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = 'editar'
    },

     async deleteItem(item) {
      if (!confirm("Tem a certeza que quer eliminar este utilizador?")){
        return
      }
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.status = 0;
      this.deletedItem = this.editedItem
      await this.$store.dispatch("deleteUser", this);
      this.initialize();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

   async save() {
      this.userMsg = "A validar...";
      // this.editedItem.role_id = 1;
      if (this.estado == "novo") {
        if (this.editedItem.name == "") {
          this.userMsg = "Introduza o nome do utilizador a criar";
        } else if (this.editedItem.email == "") {
          this.userMsg = "Introduza o email do utilizador a criar";
        } 
        else {

          this.editedItem.user_level = this.editedItem.user_level_id
          this.editedItem.password = '213063654BD277128095F74B89B8BD187DF3902C0D971297F3FAF3522F8B0C8A'

          delete this.editedItem.user_level_id
          delete this.editedItem.password2

          await this.$store.dispatch("createUsers", this);
        }
      } else {
          
          this.editedItem.user_level = this.editedItem.user_level_id

          // delete this.editedItem.user_level_id
          delete this.editedItem.password
          delete this.editedItem.password2
          delete this.editedItem.entrou
          delete this.editedItem.last_update_dt

          await this.$store.dispatch("updateUsers", this);
      }
    }
  }
};
</script>
